import { JobWorkerStatusEnum } from '@/types/graphql';

export const ACCEPTANCE_STATUSES_TO_HIRED_WORKERS = [
  JobWorkerStatusEnum.HIRED,
  JobWorkerStatusEnum.IN_PROGRESS,
  JobWorkerStatusEnum.COMPLETED,
  JobWorkerStatusEnum.APPROVED,
  JobWorkerStatusEnum.PAID,
  JobWorkerStatusEnum.EXPIRED,
  JobWorkerStatusEnum.REJECTED,
  JobWorkerStatusEnum.CONFIRMED,
];

enum ExtraAllOption {
  ALL = 'ALL',
}

export const JobWorkerStatusFilterEnum = {
  ...ExtraAllOption,
  ...JobWorkerStatusEnum,
};

export type JobWorkerStatusFilterEnumType =
  | JobWorkerStatusEnum
  | ExtraAllOption;

// These are STORED VALUES, not display copy: the modals submit the selected
// string straight into the cancel mutation and the backend persists it
// verbatim, so every BI query and report groups on these literals. The
// GRAVY-10392 terminology pass deliberately leaves them untouched (same rule
// as vexo step labels / hiredFrom values) — renaming one forks the persisted
// cancellation-reason taxonomy at the deploy date. If Product wants the copy
// changed, add a display-label layer and keep these stable.
export enum CancelJobReason {
  EventCancelled = 'Event cancelled',
  SupervisorNoAvailable = 'Shift supervisor no longer available',
  IncorrectJobDetails = 'Posted with incorrect job details',
  JobRequirementsChanged = 'Job requirements changed',
  StaffNoNeeded = 'Staff no longer needed',
  FoundStaffElsewhere = 'Found staff elsewhere',
  InclementWeather = 'Inclement weather',
  Other = 'Other',
}

export enum CancelRemoveReason {
  WorkerUnavailable = 'Worker reported they are unavailable',
  StaffNoNeeded = 'Staff no longer needed',
  ShiftOverbooked = 'Shift was overbooked',
  DontWantThisWorker = 'I do not want this worker',
  Other = 'Other',
}

export enum ContextCancelRemoveModal {
  CancelJob = 'CancelJob',
  CancelOrder = 'CancelOrder',
  RemoveWorker = 'RemoveWorker',
}

export enum ContextConfirmModalCancellation {
  CancelJob = 'CancelJob',
  CancelOrder = 'CancelOrder',
}

export enum OrderFilterKeysEnum {
  ACCOUNT = 'account',
  AGENCY = 'agency',
  APPLY_DISJUNCTIVELY = 'applyDisjunctively',
  CUSTOMER = 'customer',
  END_AT = 'endAt',
  JOBS_COUNT = 'jobsCount',
  QUERY = 'query',
  START_AT = 'startAt',
  STATUS = 'status',
  TAGS = 'tags',
  UUID = 'uuid',
}
